<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg669"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs673"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath683"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path681" /></clipPath></defs><g
     id="g675"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g677"><g
         id="g679"
         clip-path="url(#clipPath683)"><g
           id="g685"
           transform="translate(173.6011,313.8574)"><path
             d="m 0,0 v -8.716 c 0,-17.415 5.933,-33.445 15.888,-46.179 6.113,-7.818 9.268,-17.546 9.269,-27.47 l 0.003,-24.979 h 99.755 l 0.003,24.99 c 10e-4,10.018 3.299,19.769 9.439,27.684 2.542,3.276 4.818,6.769 6.797,10.446 l 53.127,92.019 c 5.18,8.972 2.106,20.445 -6.866,25.625 -8.972,5.181 -20.445,2.106 -25.625,-6.866 L 150.074,46.263 v 103.221 c 0,10.361 -8.399,18.76 -18.759,18.76 -10.36,0 -18.759,-8.399 -18.759,-18.76 v 22.399 c 0,10.361 -8.399,18.76 -18.76,18.76 -10.36,0 -18.759,-8.399 -18.759,-18.76 v -22.399 c 0,10.361 -8.399,18.76 -18.759,18.76 -10.361,0 -18.759,-8.399 -18.759,-18.76 v -25.063 c 0,10.361 -8.399,18.759 -18.76,18.759 C 8.399,143.18 0,134.782 0,124.421 V 35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path687" /></g><g
           id="g689"
           transform="translate(335.3906,380.4116)"><path
             d="m 0,0 -21.164,-36.617 c -12.186,7.063 -28.052,5.379 -38.483,-5.052 -12.44,-12.44 -12.44,-32.608 0,-45.048"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path691" /></g><g
           id="g693"
           transform="translate(211.1196,389.2515)"><path
             d="M 0,0 V 49.027"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path695" /></g><g
           id="g697"
           transform="translate(248.6382,463.3418)"><path
             d="M 0,0 V -74.09"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path699" /></g><g
           id="g701"
           transform="translate(286.1567,463.3418)"><path
             d="M 0,0 V -74.09"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path703" /></g><path
           d="M 307.375,164.643 H 189.901 v 41.871 h 117.474 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path705" /><path
           d="M 312.227,164.643 H 185.05 V 7.5 h 127.177 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path707" /><g
           id="g709"
           transform="translate(449.4663,82.7969)"><path
             d="m 0,0 0.002,19.133 c 0.002,7.669 2.526,15.134 7.227,21.194 1.946,2.508 3.689,5.183 5.204,7.998 l 40.674,70.449 c 3.966,6.87 1.613,15.653 -5.257,19.619 -6.869,3.966 -15.653,1.613 -19.619,-5.257 l -8.969,-15.535 v 79.027 c 0,7.932 -6.43,14.362 -14.362,14.362 -7.932,0 -14.362,-6.43 -14.362,-14.362 v 17.148 c 0,7.932 -6.43,14.363 -14.362,14.363 -7.932,0 -14.362,-6.431 -14.362,-14.363 v -17.148 c 0,7.932 -6.43,14.362 -14.362,14.362 -7.932,0 -14.363,-6.43 -14.363,-14.362 v -19.189 c 0,7.932 -6.429,14.362 -14.361,14.362 -7.933,0 -14.363,-6.43 -14.363,-14.362 V 75.51 c 0,-13.334 4.543,-25.606 12.164,-35.355 4.68,-5.986 7.096,-13.433 7.096,-21.031 L -76.373,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path711" /></g><g
           id="g713"
           transform="translate(477.6978,215.9331)"><path
             d="m 0,0 -16.203,-28.034 c -9.33,5.408 -21.477,4.118 -29.463,-3.868 -9.524,-9.524 -9.524,-24.965 0,-34.489"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path715" /></g><g
           id="g717"
           transform="translate(382.5557,222.7012)"><path
             d="M 0,0 V 37.535"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path719" /></g><g
           id="g721"
           transform="translate(411.2803,279.4248)"><path
             d="M 0,0 V -56.724"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path723" /></g><g
           id="g725"
           transform="translate(440.0044,279.4248)"><path
             d="M 0,0 V -56.724"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path727" /></g><g
           id="g729"
           transform="translate(437.79,82.7969)"><path
             d="M 0,0 H 18.459 V -32.056 H -71.479 V 0 H -35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path731" /></g><path
           d="M 459.963,50.741 H 362.596 V 7.5 h 97.367 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path733" /><g
           id="g735"
           transform="translate(14.0698,244.4263)"><path
             d="m 0,0 v 0 c 6.283,3.627 14.316,1.475 17.943,-4.808 l 8.204,-14.209 v 72.278 c 0,7.255 5.881,13.135 13.135,13.135 7.255,0 13.136,-5.88 13.136,-13.135 v 15.684 c 0,7.255 5.881,13.136 13.135,13.136 7.255,0 13.136,-5.881 13.136,-13.136 V 53.261 c 0,7.255 5.881,13.135 13.135,13.135 7.255,0 13.136,-5.88 13.136,-13.135 v -17.55 c 0,7.255 5.881,13.136 13.135,13.136 7.255,0 13.136,-5.881 13.136,-13.136 v -93.224 c 0,-12.195 -4.154,-23.419 -11.125,-32.335 -4.28,-5.475 -6.489,-12.286 -6.49,-19.235 l -0.002,-17.491 h -69.85 l -0.002,17.499 c -0.002,7.014 -2.31,13.842 -6.61,19.384 -1.78,2.294 -3.374,4.74 -4.759,7.315 L -4.808,-17.943 C -8.435,-11.661 -6.283,-3.627 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path737" /></g><g
           id="g739"
           transform="translate(32.0132,239.6182)"><path
             d="m 0,0 14.819,-25.64 c 8.534,4.946 19.643,3.766 26.947,-3.538 8.711,-8.71 8.711,-22.832 0,-31.543"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path741" /></g><g
           id="g743"
           transform="translate(119.0298,245.8081)"><path
             d="M 0,0 V 34.33"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path745" /></g><g
           id="g747"
           transform="translate(92.7588,297.687)"><path
             d="M 0,0 V -51.879"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path749" /></g><g
           id="g751"
           transform="translate(66.4878,297.687)"><path
             d="M 0,0 V -51.879"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path753" /></g><path
           d="m 51.63,88.534 h 82.256 v 29.319 H 51.63 Z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path755" /><g
           id="g757"
           transform="translate(137.2842,22.7544)"><path
             d="M 0,0 V -15.254 H -89.051 V 65.779 H 0 V 35"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path759" /></g><g
           id="g761"
           transform="translate(504.5,397.1523)"><path
             d="m 0,0 c 0,20.417 -16.61,37.026 -37.026,37.026 h -10.58 c -6.631,0 -12.026,5.395 -12.026,12.026 0,6.632 5.395,12.027 12.026,12.027 h 10.58 c 4.846,0 9.198,-2.885 11.086,-7.349 2.69,-6.358 10.027,-9.332 16.382,-6.644 6.358,2.69 9.332,10.024 6.643,16.382 -4.854,11.476 -14.998,19.559 -26.901,21.908 v 9.472 c 0,6.903 -5.596,12.5 -12.5,12.5 -6.904,0 -12.5,-5.597 -12.5,-12.5 v -9.474 c -16.977,-3.365 -29.816,-18.372 -29.816,-36.322 0,-20.416 16.61,-37.026 37.026,-37.026 h 10.58 C -30.395,12.026 -25,6.631 -25,0 c 0,-6.631 -5.395,-12.026 -12.026,-12.026 h -10.58 c -4.997,0 -9.398,3.007 -11.212,7.66 -2.509,6.431 -9.756,9.613 -16.188,7.104 -6.432,-2.508 -9.612,-9.756 -7.104,-16.187 4.692,-12.032 15.001,-20.487 27.294,-22.884 v -9.462 c 0,-6.904 5.596,-12.5 12.5,-12.5 6.904,0 12.5,5.596 12.5,12.5 v 9.475 C -12.839,-32.956 0,-17.949 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path763" /></g></g></g></g></svg>
</template>
